import { useaxios } from "../../../utils/useaxios";
export default (customer_id, mizania_date) => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    return useaxios('report/mizania/customer_loan_in.php', { customer_id, mizania_date }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            return res?.data;
        }
    });
}